import s1 from '../img/blogs/s-1.jpg';
import s3 from '../img/blogs/s-3.jpg';
import s2 from '../img/blogs/s-2.jpg';
import s4 from '../img/blogs/s-4.jpg';
import s5 from '../img/blogs/s-5.png';

const projects = [
  {
    id: 1,
    title: 'Create Professional logo or business cards for your business',
    date: '01',
    month: 'April',
    image: s1,
    link: 'https://www.fiverr.com/pranaykharabe/design-a-professional-certificate-or-business-cards-for-your-business',
  },
  {
    id: 2,
    title: 'Create and Build Professional Landing Page Design',
    date: '01',
    month: 'April',
    image: s2,
    link: 'https://www.fiverr.com/pranaykharabe/build-a-professional-html-landing-page-for-you',
  },
  {
    id: 3,
    title: 'Build Personal Portfolio/Resume Website for you',
    date: '01',
    month: 'April',
    image: s3,
    link: 'https://www.fiverr.com/pranaykharabe/build-and-develop-personal-portfolio-online-resume-website',
  },
  {
    id: 4,
    title: 'Build College Projects related to Web Development',
    date: '01',
    month: 'April',
    image: s4,
    link: 'https://www.fiverr.com/pranaykharabe/code-your-college-projects',
  },
  {
    id: 4,
    title: 'Build your full stack MERN website',
    date: '2021',
    month: 'May',
    image: s5,
    link: 'https://www.fiverr.com/pranaykharabe/code-your-college-projects',
  },
];

export default projects;
